import styles from './MetricCards.module.scss';

const MetricCard = ({ data }) => {
  const { title, unit, value, progressPercentage, items } = data;

  return (
    <div className={styles.metricCard}>
      <div className={styles.cardContent}>
        <div className={styles.headerRow}>
          <h3 className={styles.title}>{title}</h3>
        </div>

        <div className={styles.valueSection}>
          <div className={styles.valueRow}>
            <span className={styles.mainValue}>{value}</span>
            {unit && (
              <span className={styles.unit}>{unit}</span>
            )}
          </div>

          {progressPercentage !== undefined && (
            <div className={styles.progressBarContainer}>
              <div
                className={styles.progressBar}
                style={{
                  width: `${Math.min(progressPercentage, 100)}%`
                }}
              />
            </div>
          )}
        </div>

        <div className={styles.metricsGrid}>
          {items?.map((item, index) => (
            <div key={index} className={styles.metricItem}>
              <div className={styles.itemValue}>
                {item.value}
              </div>
              <div className={styles.itemTitle}>
                {item.title}
              </div>
              <div className={`${styles.accentLine} ${index % 2 === 0 ? styles.accentLineGray : styles.accentLineBlue}`} />
            </div>
          ))}
        </div>
      </div>

      <div className={styles.backgroundPattern} />
    </div>
  );
};

export default function MetricCards({ metrics }) {
  return (
    <div className={styles.metricsContainer}>
      <div className={styles.cardsGrid}>
        {metrics.map((metric, index) => (
          <MetricCard
            key={index}
            data={metric}
          />
        ))}
      </div>
    </div>
  );
}
